var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChrome(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Icons",
    xmlns: "http://www.w3.org/2000/svg",
    width: 66.054,
    height: 66.054,
    viewBox: "0 0 66.054 66.054",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Color-",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "chrome"
  }, /*#__PURE__*/React.createElement("path", {
    id: "chrome-icon-path",
    d: "M5.8,11.506A33.018,33.018,0,0,1,60.26,18.037c-7.492,0-19.223,0-25.577,0-4.609,0-7.583-.1-10.805,1.594a15.238,15.238,0,0,0-7.644,10.032L5.8,11.5Z",
    transform: "translate(2.179 0)",
    fill: "#ea4335"
  }), /*#__PURE__*/React.createElement("path", {
    id: "chrome-icon-path-2",
    "data-name": "chrome-icon-path",
    d: "M16.015,27A10.977,10.977,0,1,0,26.992,16.018,10.993,10.993,0,0,0,16.015,27Z",
    transform: "translate(6.023 6.025)",
    fill: "#4285f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "chrome-icon-path-3",
    "data-name": "chrome-icon-path",
    d: "M37.277,43.3a14.8,14.8,0,0,1-17.321-7.018Q12.639,23.6,5.357,10.9C-7.324,30.332,3.605,56.814,26.623,61.336L37.277,43.3Z",
    transform: "translate(0 4.1)",
    fill: "#34a853"
  }), /*#__PURE__*/React.createElement("path", {
    id: "chrome-icon-path-4",
    "data-name": "chrome-icon-path",
    d: "M34.75,16.018a15.037,15.037,0,0,1,2.774,18.494C34.906,39.026,26.547,53.132,22.5,59.964a33.052,33.052,0,0,0,33.2-43.946H34.749Z",
    transform: "translate(8.462 6.025)",
    fill: "#fbbc05"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChrome);
export default __webpack_public_path__ + "static/media/chrome.32bd80da932737e7c0abf66cafb962e7.svg";
export { ForwardRef as ReactComponent };